export default __webpack_public_path__ + "static/media/login_signup_ic.5326b4fc.svg";